import { createContext, useContext, useState, useCallback } from "react";

const EmployeeContext = createContext(null);

export const EmployeeProvider = ({ children }) => {
  const [employee, setEmployee] = useState(null);

  const login = useCallback((code, name, companyName, isAdmin = false, companyCode = null) => {
    setEmployee({ code, name, companyName, companyCode: companyCode || companyName, isAdmin });
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("zeitflow_employee_code");
    localStorage.removeItem("zeitflow_employee_name");
    localStorage.removeItem("zeitflow_company_name");
    localStorage.removeItem("zeitflow_company_code");
    localStorage.removeItem("zeitflow_is_admin");
    setEmployee(null);
  }, []);

  return (
    <EmployeeContext.Provider value={{ employee, login, logout }}>
      {children}
    </EmployeeContext.Provider>
  );
};

export const useEmployee = () => {
  const context = useContext(EmployeeContext);
  if (!context) {
    throw new Error("useEmployee must be used within EmployeeProvider");
  }
  return context;
};
